import { permissions } from './permissions';
import {
  firstPathState,
  regionState,
  customersToRegionState,
  embeddedParentOriginState,
  navMenuFeatures,
  processedTenantsState
} from './common-atoms';
import { BACKGROUND_OPERATIONS_STATE, CLEAR_ENV_STATE } from './kafka-events-atoms';
import { whiteLabelThemeConfigState } from './whitelabel-theme-settings';
import { globalSearchOpenState, globalSearchPendingTextState } from './global-search-atoms';

export const Atoms = {
  permissions,
  firstPathState,
  embeddedParentOriginState,
  regionState,
  navMenuFeatures,
  customersToRegionState,
  processedTenantsState,
  BACKGROUND_OPERATIONS_STATE,
  CLEAR_ENV_STATE,
  whiteLabelThemeConfigState,
  globalSearchOpenState,
  globalSearchPendingTextState
};
